module.exports = __webpack_public_path__ + "img/s1_m_img2.385fc1c8.png";